import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

const scheduleButtonStyles = makeStyles({
  root: {
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: 'bold',
    textTransform: 'none',
    lineHeight: '120%',
    backgroundColor: '#58C22E',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#3A9E12',
    },
    padding: props => (props.size === 'large' ? '14px 60px' : '10px 24px'),
  },
});

export default function ScheduleButton(props) {
  const { children, size, type, onClick } = props;
  const classes = scheduleButtonStyles(props);

  return (
    <Button size={size} type={type} onClick={onClick} className={classes.root}>
      {children}
    </Button>
  );
}

ScheduleButton.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['medium', 'large']),
  type: PropTypes.string,
  onClick: PropTypes.func,
};

ScheduleButton.defaultProps = {
  size: 'medium',
  type: 'button',
  onClick: () => { },
};
